
import AppEditContact from "@/components/contacts/ContactEdit.vue";
import { Contact } from "@/models/base";
import { ToolbarService } from "@/services/toolbar-service";
import { PendingChangesNotifier } from "@/utils/pending-changes-notifier";
import Vue from "vue";
import { ContactAddress } from "@/models/base";
import { getContactServiceByGroupId } from "@/utils/services/contact-services";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ConfirmResult } from "winfakt-vue-components";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data() {
		let warningText = () => {
			return this.$ct("save-confirm").toString();
		};
		return {
			id: 0,
			contact: new Contact(),
			pendingChangesNotifier: new PendingChangesNotifier(this, "contact", {warningText}),
			ready: false
		};
	},
	props: {
		groupId: {
			type: Number
		}
	},
	computed: {
		title():TranslateResult{
			return ToolbarService.title;
		},
		isInfo():boolean {
			return this.$route.fullPath.includes("/info/");
		},
		baseRoutePath():string{
			let routeName = "customers";
			if (this.contact.GroupID == 2) {
				routeName = "suppliers";
			}
			if (this.contact.GroupID == 3) {
				routeName = "prospects";
			}
			return `/contacts/${routeName}`;
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		onSave() {
			this.$emit("saved");
			this.pendingChangesNotifier.changesPending = false;
			this.$router.push(this.baseRoutePath);
		},
		onDelete() {
			let routeName = "customers";
			if (this.contact.GroupID == 2) {
				routeName = "suppliers";
			}
			if (this.contact.GroupID == 3) {
				routeName = "prospects";
			}
			this.pendingChangesNotifier.changesPending = false;
			this.$router.push(`/contacts/${routeName}`);
		},
		async onContactChange(contact: Contact) {
			this.contact = contact;
		},
		async save(){
			let el = this.$refs.root as any;
			if (!el) return;
			await el.save();
		}
	},
	async created() {
		if (this.groupId == 3 && !checkHasModule(MODULE.PROSPECTEN, this.$router)) {
			throw new Error("MISSING MODULE");
		}
		if (this.groupId == 2) {
			this.contact.Vat = "";
		}
		try{

			let titleKey = "titles.";

			this.id = parseInt(this.$route.params.id);
			this.contact.GroupID = this.groupId;
			this.contact.MainAddress = new ContactAddress();
			this.contact.MainAddress.IsMainAddress = true;
			this.contact.Addresses = [this.contact.MainAddress as ContactAddress];

			let titleGroups = ["client", "supplier", "prospect"];
			titleKey += titleGroups[this.contact.GroupID - 1];
			titleKey += "-";

			let contactService = getContactServiceByGroupId(this.contact.GroupID);

			if (this.id) {
				this.contact = await contactService.getContact(this.id);
				titleKey += "edit";
				await this.$nextTick();
				this.pendingChangesNotifier.changesPending = false;
			} else {
				titleKey += "new";
				if (this.contact.ExtraFields){
					DossierConfigService.getExtraFieldNamesConfigs().getContactNamesByGroupID(this.groupId).setDefaultValues(this.contact.ExtraFields);
				}
			}
			ToolbarService.title = this.$ct(titleKey,{id: this.contact.ComputedFriendlyID});
		}catch(err){
			console.error(err);
		}
		this.ready =true;
	},
	components: {
		AppEditContact
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	},
	async beforeRouteLeave(to, from, next) {
		if(this.isInfo){
			next();
			return;
		}
		let confirm = await this.pendingChangesNotifier.askToSave();
		if (confirm == ConfirmResult.CANCEL){
			return;
		}
		if (confirm == ConfirmResult.YES) {
			await this.save();
		}
		let contact = new Contact(this.contact.getJSON());
		let contactService = getContactServiceByGroupId(contact.GroupID);
		contactService.lastOpenedItem.setLastOpenedItem(contact.getJSON());
		next();
	}
});
